import React, { useState } from "react";
import axios from "axios";
import Header from "./Header";
import abaStudent from "../images/abacusStudents.jpeg";
import abacus from "../images/abacus.jpg";
import boyAbacus from "../images/boyAbacus.jpg";
import Footer from "./Footer";
import { Constant } from "../helper/Constants";

export default function FranchiseEnquiry() {
  const [openModal, setOpenModal] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");
  const [statusType, setStatusType] = useState("");

  const isEmail = (email) =>
    /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);

  const validate = () => {
    const e = {};
    if (!formData.name.trim()) e.name = "Name can't be blank";
    if (!formData.email.trim()) e.email = "Email can't be blank";
    else if (!isEmail(formData.email)) e.email = "Invalid email";
    if (!formData.phone.trim()) e.phone = "Phone can't be blank";
    if (!formData.location.trim()) e.location = "Location can't be blank";
    return e;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
    setErrors((p) => ({ ...p, [name]: "" }));
  };

  const handleSubmit = async () => {
    const v = validate();
    if (Object.keys(v).length) {
      setErrors(v);
      return;
    }

    setSubmitting(true);
    try {
      await axios.post(Constant.postUrls.submitFranchiseEnquiry, formData);

      setStatusType("success");
      setStatusMsg(
        "Thank you! Your franchise enquiry has been submitted."
      );

      setFormData({
        name: "",
        email: "",
        phone: "",
        location: "",
        message: "",
      });

      setTimeout(() => {
        setOpenModal(false);
        setStatusMsg("");
      }, 1500);
    } catch (err) {
      setStatusType("error");
      setStatusMsg(
        err?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Header />

      {/* ================= MOBILE ONLY RESPONSIVE CSS ================= */}
      <style>{`
        @media (max-width: 768px) {

          .hero-section {
            height: auto !important;
          }

          .hero-content {
            padding: 80px 6% !important;
          }

          .hero-content h1 {
            font-size: 28px !important;
            line-height: 1.3;
          }

          .earning-row {
            flex-direction: column !important;
            gap: 25px !important;
          }

          .earning-row img {
            width: 100% !important;
            height: auto !important;
          }

          .earning-text {
            width: 100% !important;
          }

          .stats-row {
            flex-wrap: wrap !important;
          }

          .stat-card {
            flex: 1 1 48% !important;
          }

          .benefits-row {
            flex-direction: column !important;
          }

          .benefits-row > div {
            width: 100% !important;
          }
        }
      `}</style>

      {/* ================= FULL ORIGINAL UI ================= */}
      <div style={{ fontFamily: "Poppins, sans-serif", width: "100%" }}>
        {/* HERO SECTION */}
        <div
          className="hero-section"
          style={{
            position: "relative",
            width: "100%",
            height: "520px",
            backgroundImage:
              "url('https://images.unsplash.com/photo-1522202176988-66273c2fd55f')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0,0,0,0.55)",
            }}
          />

          <div
            className="hero-content"
            style={{
              position: "relative",
              zIndex: 2,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              padding: "0 8%",
              color: "#fff",
              maxWidth: "700px",
            }}
          >
            <h1 style={{ fontSize: 42, fontWeight: 700 }}>
              START YOUR OWN ABACUS <br /> LEARNING CENTER
            </h1>

            <p style={{ margin: "20px 0" }}>
              WITH THREE DIMENSIONAL <br /> EARNING OPPORTUNITIES
            </p>

            <button
              onClick={() => setOpenModal(true)}
              style={{
                width: 160,
                padding: "12px",
                background: "#ff6f6f",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                fontWeight: 600,
              }}
            >
              Apply Now
            </button>
          </div>
        </div>

        {/* TEXT STRIP */}
        <div style={{ padding: "50px 10%", textAlign: "center" }}>
          <h2>
            The education sector is booming.{" "}
            <span style={{ color: "#ff6f6f" }}>
              Create your success story with VASA-Abacus
            </span>
          </h2>
        </div>

        {/* THREE DIMENSIONAL EARNINGS */}
        <div style={{ padding: "80px 10%" }}>
          <h2 style={{ textAlign: "center", fontSize: 34 }}>
            AN ABACUS FRANCHISE OPPORTUNITY WITH <br />
            <span style={{ color: "#ff6f6f" }}>
              'THREE DIMENSIONAL EARNINGS'
            </span>
          </h2>

          {[
            {
              title: "CONVENTIONAL ABACUS CLASSES",
              desc:
                "With a VASA-Abacus franchise, you can start your own Abacus classes for students aged 5 to 14. You will receive all the necessary resources, training, and support to ensure the success and growth of your business.",
              img: abaStudent,
            },
            {
              title: "SCHOOL TIE-UPS FOR ABACUS LAB",
              desc:
                "This is an excellent earning opportunity. Partner with schools to offer Abacus classes. Many schools are incorporating Abacus into the curriculum for students from 1st to 7th grade, providing a substantial business opportunity.",
              img: boyAbacus,
            },
            {
              title: "LINGO BINGO – MATH PROGRAM",
              desc:
                "Introducing Lingo Bingo, an exclusive offline program tailored for children aged 5 to 6, nurturing their numerical understanding from an early age.",
              img: abacus,
            },
          ].map((item, i) => (
            <div
              key={i}
              className="earning-row"
              style={{
                display: "flex",
                gap: 40,
                marginTop: 60,
                alignItems: "center",
              }}
            >
              <img
                src={item.img}
                alt=""
                style={{ width: "45%", borderRadius: 8, height: 350 }}
              />
              <div className="earning-text" style={{ width: "55%" }}>
                <h3>{item.title}</h3>
                <p style={{ lineHeight: 1.8 }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* STATS */}
        <div
          className="stats-row"
          style={{
            display: "flex",
            gap: 25,
            padding: "60px 8%",
          }}
        >
          {[
            ["25 Years", "Skill Training Leadership", "#FFF9C4"],
            ["17", "Countries", "#E9FFD9"],
            ["2,000+", "Centers", "#E3F6FF"],
            ["1,000,000+", "Children Benefited", "#F4EBFF"],
          ].map(([title, text, bg], i) => (
            <div
              key={i}
              className="stat-card"
              style={{
                flex: 1,
                background: bg,
                padding: "35px",
                borderRadius: 14,
                textAlign: "center",
                fontWeight: 600,
              }}
            >
              <div style={{ fontSize: 30 }}>{title}</div>
              <div>{text}</div>
            </div>
          ))}
        </div>

        {/* BENEFITS */}
        <div
          className="benefits-row"
          style={{ padding: "70px 10%", display: "flex", gap: 40 }}
        >
          <div style={{ width: "50%" }}>
            <h2>
              BENEFITS OF{" "}
              <span style={{ color: "#ff6f6f" }}>VASA-ABACUS FRANCHISE</span>
            </h2>
            <p style={{ lineHeight: 1.8 }}>
              VASA-Abacus Franchise offers an exceptional earning opportunity
              with flexible time management.
            </p>
            <button
              onClick={() => setOpenModal(true)}
              style={{
                marginTop: 20,
                padding: "12px 25px",
                background: "#ff6f6f",
                color: "#fff",
                border: "none",
                borderRadius: 5,
              }}
            >
              Apply Now
            </button>
          </div>
        </div>
      </div>

      {/* MODAL (UNCHANGED) */}
      {openModal && (
        <div onClick={() => setOpenModal(false)} style={overlay}>
          <div onClick={(e) => e.stopPropagation()} style={modal}>
            <span onClick={() => setOpenModal(false)} style={closeBtn}>
              ×
            </span>

            <h3 style={{ marginBottom: 20 }}>Franchise Enquiry</h3>

            {["name", "email", "phone", "location"].map((k) => (
              <div key={k}>
                <input
                  name={k}
                  placeholder={k.toUpperCase()}
                  value={formData[k]}
                  onChange={handleChange}
                  style={input}
                />
                {errors[k] && <div style={error}>{errors[k]}</div>}
              </div>
            ))}

            <textarea
              name="message"
              placeholder="Additional Details (optional)"
              value={formData.message}
              onChange={handleChange}
              style={{ ...input, height: 80 }}
            />

            {statusMsg && (
              <p style={{ color: statusType === "success" ? "green" : "red" }}>
                {statusMsg}
              </p>
            )}

            <button
              onClick={handleSubmit}
              disabled={submitting}
              style={submitBtn}
            >
              {submitting ? "Submitting..." : "Submit Enquiry"}
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

/* ================= STYLES ================= */
const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 999,
};

const modal = {
  width: 420,
  background: "#fff",
  borderRadius: 10,
  padding: 30,
  position: "relative",
};

const closeBtn = {
  position: "absolute",
  right: 14,
  top: 10,
  fontSize: 22,
  cursor: "pointer",
};

const input = {
  width: "100%",
  padding: 10,
  marginBottom: 6,
  borderRadius: 4,
  border: "1px solid #ccc",
};

const submitBtn = {
  width: "100%",
  padding: 12,
  background: "#ff6f6f",
  color: "#fff",
  border: "none",
  borderRadius: 6,
};

const error = {
  color: "red",
  fontSize: 12,
};
